
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Loader2 } from 'lucide-react';

interface AdminSettingsLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  userRole?: string;
  onLogout: () => void;
}

const AdminSettingsLayout: React.FC<AdminSettingsLayoutProps> = ({
  children,
  isLoading = false,
  userRole = '',
  onLogout
}) => {
  const navigate = useNavigate();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header isLoggedIn={true} isAdmin={true} userRole={userRole} onLogout={onLogout} />
        <div className="flex-grow flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="h-12 w-12 animate-spin mx-auto text-primary-blue" />
            <p className="mt-4 text-gray-600">Loading settings...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={true} isAdmin={true} userRole={userRole} onLogout={onLogout} />
      <main className="flex-grow py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default AdminSettingsLayout;
